<template lang="pug">
  v-slide-y-transition(mode="out-in")
    v-container(fluid)
      confirm(ref="confirm")

      v-toolbar.mb-3(dark, color="primary")
        v-text-field(append-icon="search", :elevation="1", label="Filtrar", @keyup="handleSearchKeyUp", single-line, hide-details, v-model="search")
        v-btn(text, class="right", to="/bookings/create") Añadir nueva reserva

      v-data-table.elevation-1(:loading="isLoading()", :item-class="getRowClass", disable-pagination, :headers="tableHeaders", :items="bookings", hide-default-footer)
        template(v-slot:item.details="{ item }")
          span(v-html="getDetailsList(item)")
        template(v-slot:item.customer="{ item }") {{getCustomerName(item)}}
        template(v-slot:item.total="{ item }") {{item.total | currency}}
        template(v-slot:item.createdAt="{ item }") {{item.createdAt | formatDate}}
        template(v-slot:item.options="{ item }")
          v-btn(:href="getBonoUrl(item)", target="_blank", text, icon, color="success")
            v-icon file_download
          template(v-if="item.status === 'CREATED' && !item.cancelled")
            v-btn(@click="handleConfirm(item)", text, icon, color="success")
              v-icon check
            v-btn(:to="`/bookings/${item.id}/edit`", text, icon, color="primary")
              v-icon edit
          template(v-if="item.status === 'CONFIRMED' && !item.cancelled")
            v-btn(@click="handleInvoice(item)", text, icon, color="warning")
              v-icon money
            v-btn(:to="`/bookings/${item.id}/edit`", text, icon, color="primary")
              v-icon edit
          template(v-if="!item.cancelled")
            v-btn(@click="handleDelete(item)", text, icon, color="red")
              v-icon delete
      v-layout(flex align-center justify-center)
        v-btn(text, color="blue", style="margin: 20px 0 0", :disabled="isLoading()", @click="loadNextPage")
          span(v-if="!isLoading()") Cargar más
          v-progress-circular(indeterminate, :size="25", :width="2", color="primary" v-else)
</template>

<style>
  .cancelled {
    color: red !important;
    text-decoration: line-through !important;
  }
</style>

<script>
  import { accentsTidy } from '@/utils/search';

  export default {
    data() {
      return {
        currentPage: null,
        currentSearchText: '',
        loading: false,
        search: null,
        bookings: [],
        tableHeaders: [
          {
            text: 'Localizador',
            align: 'left',
            sortable: false,
            value: 'locator',
          },
          {
            text: 'Fecha',
            align: 'left',
            sortable: false,
            value: 'createdAt',
          },
          {
            text: 'Cliente',
            align: 'left',
            sortable: false,
            value: 'customer',
          },
          {
            text: 'Estancias',
            align: 'left',
            sortable: false,
            value: 'details',
          },
          {
            text: 'Total',
            align: 'right',
            value: 'total',
            sortable: false,
          },
          {
            text: 'Opciones',
            align: 'right',
            sortable: false,
            value: 'options',
          },
        ],
      };
    },
    created() {
      this.fetchPage(0);
    },
    methods: {
      isLoading() {
        return this.loading;
      },
      fetchPage(page, searchText) {
        if (typeof searchText !== 'undefined') {
          this.currentSearchText = searchText;
        }
        this.currentPage = page;
        this.loading = true;
        if (page === 0) {
          this.bookings = [];
        }
        api.get(`/bookings?page=${page}&search=${this.currentSearchText}`).then((res) => {
          this.bookings = [...this.bookings, ...res.data.data];
        }).catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err);
        }).finally(() => {
          this.loading = false;
        });
      },
      loadNextPage() {
        this.fetchPage(this.currentPage + 1);
      },
      getCustomerName(item) {
        let showName = '';
        if (item.user && item.user.info) {
          if (item.user.info.fiscalName) {
            showName = item.user.info.fiscalName;
          }
          if (item.user.info.commercialName) {
            showName = item.user.info.commercialName;
          }
        } else {
          showName = item.user.email;
        }
        if (showName.length < 1) {
          showName = [item.user.firstName, item.user.lastName].join(' ');
        }
        if (item.finalCustomer) {
          showName += ` (${item.finalCustomer})`;
        }
        return showName;
      },
      handleConfirm(item) {
        this.$refs.confirm.open('Confirmar', '¿Estás seguro?').then((confirm) => {
          if (confirm) {
            api.put(`/bookings/${item.id}/confirm`).then(() => {
              this.bookings[this.bookings.indexOf(item)].status = 'CONFIRMED';
            }).catch(this.handleError);
          }
        });
      },
      handleInvoice(item) {
        this.$refs.confirm.open('Facturar', '¿Estás seguro?').then((confirm) => {
          if (confirm) {
            api.put(`/bookings/${item.id}/invoice`).then(() => {
              this.bookings[this.bookings.indexOf(item)].status = 'INVOICED';
            }).catch(this.handleError);
          }
        });
      },
      bookingsFilter(items, search) {
        if (search) {
          const rexp = new RegExp(accentsTidy(search), 'gi');
          return items.filter(i => accentsTidy(String(i.locator)).match(rexp)
              || accentsTidy(this.getCustomerName(i)).match(rexp)
              || accentsTidy(this.getDetailsList(i)).match(rexp));
        }
        return items;
      },
      getDetailsList(item) {
        const list = [];
        item.details.forEach(i => list.push(i.description));
        return list.join('<br>');
      },
      getRowClass(item) {
        return item.cancelled ? 'cancelled' : '';
      },
      getBonoUrl(item) {
        return `https://${process.env.API_HOST}/bookings/${item.id}/bono?token=${store.state.user.token}`;
      },
      handleSearchKeyUp(ev) {
        if (ev.keyCode === 13) {
          this.fetchPage(0, this.search);
        }
      },
      handleDelete(item) {
        this.$refs.confirm.open('Eliminar', '¿Estás seguro?').then((confirm) => {
          if (confirm) {
            api.delete(`/bookings/${item.id}`).then(() => {
              this.fetchData();
            }).catch(this.handleError);
          }
        });
      },
      handleError(err) {
        // eslint-disable-next-line no-console
        console.error(err);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/pages/Bookings/Bookings.vue